// extracted by mini-css-extract-plugin
export var box = "_38-0";
export var check = "_38-1";
export var checkboxButton = "_38-6";
export var checkboxGroup = "_38-5";
export var disabled = "_38-7";
export var ghost = "_38-9";
export var input = "_38-2";
export var label = "_38-4";
export var normal = "_38-8";
export var uncheck = "_38-3";